"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.R = void 0;
const Leaf = __importStar(require("leaf-ts"));
var R;
(function (R) {
    var _a;
    let WidgetCompileInfo;
    if (typeof NO_COMPILE_INFO === "undefined" || !NO_COMPILE_INFO) {
        WidgetCompileInfo = {
            "project": "/dev/shm/VersetProduction/verset-webapp.release/prod-497674fb-c4e34b12612d",
            "path": "src/script/probeHint/probeHint.theme/genesis/probeHint.html",
            "namespace": "R",
            "created": "2026-11-01 23:50:06"
        };
    }
    class ProbeHint extends Leaf.GeneratedWidget {
        static { _a = Leaf.CompileInfoSymbol; }
        constructor() {
            super(Leaf.WidgetThemeCenter.getThemeGenerator(ProbeHint), "ProbeHint", []);
            this.TestDatas = ProbeHint.TestDatas;
            this.BindedLists = ProbeHint.BindedLists;
            this.BindedWidgets = ProbeHint.BindedWidgets;
            this.InitialData = ProbeHint.InitialData;
            this.path = ProbeHint.path;
            this.GeneratedConstructor = ProbeHint;
            if (ProbeHint.InitialData) {
                this.renderRecursive(ProbeHint.InitialData);
            }
        }
        static { this[_a] = WidgetCompileInfo && {
            ...WidgetCompileInfo,
            namespace: "R.ProbeHint",
        }; }
        static { this.generator = function () {
            var _e = this._e.bind(this);
            var _t = this._t.bind(this);
            return _e("button", { "type": { "name": "type", "templates": [{ "type": "raw", "content": "button" }] }, "data-id": { "name": "data-id", "templates": [{ "type": "raw", "content": "openGuide" }] }, "aria-label": { "name": "aria-label", "templates": [{ "type": "raw", "content": "Connect a computer" }] }, "data-theme": { "name": "data-theme", "templates": [{ "type": "raw", "content": "genesis" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "probe-hint-598f46" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "eyebrow" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Local access" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "message" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Connect a computer to use files and terminal tools from this workspace." }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "action" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Connect computer" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n" }] })]);
        }; }
        static { this.TestDatas = []; }
        static { this.BindedLists = []; }
        static { this.BindedWidgets = []; }
        static { this.path = "/script/probeHint/probeHint.theme/genesis/probeHint"; }
        static { this.widgetName = "ProbeHint"; }
        static { this.InitialData = null; }
    }
    R.ProbeHint = ProbeHint;
    ProbeHint["prototype"].widgetName = "ProbeHint";
})(R || (exports.R = R = {}));
if (typeof NO_LESS_IN_SOURCE === "undefined" || !NO_LESS_IN_SOURCE) {
    const lessContent = "\n.probe-hint-598f46 {\n\n    & { display: block; }\n    button { display: grid; width: 100%; box-sizing: border-box; grid-template-columns: minmax(0, 1fr) auto; gap: 6px 18px; padding: 0; border: 0; background: transparent; color: inherit; text-align: left; font: inherit; cursor: pointer; }\n    .eyebrow { grid-column: 1 / -1; color: rgba(255, 255, 255, .5); font-size: 10px; font-weight: 700; letter-spacing: .1em; line-height: 1.3; text-transform: uppercase; }\n    .message { color: rgba(255, 255, 255, .82); font-size: 12px; font-weight: 400; line-height: 1.5; }\n    .action { align-self: end; color: #fff; font-size: 12px; font-weight: 650; line-height: 1.5; white-space: nowrap; }\n    button:hover .action, button:focus-visible .action { text-decoration: underline; }\n    button:focus-visible { outline: 2px solid rgba(255, 255, 255, .55); outline-offset: 4px; }\n\n\n}\n\n";
    const _global = globalThis;
    _global.lesses = _global.lesses || [];
    _global.lesses.push({ filename: __filename, less: lessContent });
}
